/*!
 * KoliBri - The accessible HTML-Standard
 */
import { b as watchValidator } from './common-D-vggmh2.js';

const validateAlignment = (component, propName, value) => {
    watchValidator(component, propName, (value) => typeof value === 'string' && alignPropTypeOptions.includes(value), new Set(alignPropTypeOptions), value, {
        defaultValue: 'top',
    });
};

const horizontalAlignOptions = ['left', 'right'];
const verticalAlignOptions = ['top', 'bottom'];
const alignPropTypeOptions = [...horizontalAlignOptions, ...verticalAlignOptions];
const validateAlign = (component, value) => {
    validateAlignment(component, '_align', value);
};

export { alignPropTypeOptions as a, validateAlignment as b, validateAlign as v };
//# sourceMappingURL=align-C8fl12z_.js.map

//# sourceMappingURL=align-C8fl12z_.js.map